<main id="main-content" class="h-screen flex flex-col pl-10 py-4 pr-4 transition-all duration-0">
    <div class="w-full flex flex-col p-2 items-center gap-2">
        <div class="w-full flex flex-row items-center justify-between">
            <div class="w-full flex gap-2 items-center justify-start">
                <h1 class="oswald-font text-3xl uppercase">
                    Emergency Evacuation Kits
                </h1>
                <div data-popover-target="popover-bottom" data-popover-placement="bottom" type="button">
                    <lucide-icon [name]="icons.CircleHelp" [size]=24 class="text-red-500"></lucide-icon>
                </div>
                <div data-popover id="popover-bottom" role="tooltip"
                    class="absolute z-30 invisible inline-block w-fit max-w-[600px] text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-md shadow-xs opacity-0">
                    <div class="px-3 py-2">
                        <p>
                            List the emergency evacuation kits and where they are kept. Click
                            <span class="inline-flex px-3 py-1 items-center justify-center rounded-md bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 text-white oswald-font">Add New</span>
                            to add one, or use <span class="inline-flex px-3 py-1 items-center justify-center rounded-md bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 text-white oswald-font">Edit</span> / <span class="inline-flex px-3 py-1 items-center justify-center rounded-md bg-gradient-to-b from-nside-gray-300 to-nside-gray-400 text-white oswald-font">Delete</span> on a row to manage it.
                        </p>
                    </div>
                    <div data-popper-arrow></div>
                </div>
            </div>
        </div>
    </div>

    <!-- MAIN CONTENT -->
    <div class="p-2 w-full flex flex-grow flex-col items-start gap-8 overflow-y-auto">
        <div class="max-h-full w-full flex flex-col gap-4">
            <div class="h-full w-full bg-white rounded-md shadow-custom-2 flex flex-col p-6 gap-4">
                <div class="w-full flex items-center justify-between">
                    <h3 class="oswald-font text-xl font-medium">Emergency Evacuation Kits</h3>
                    <button *ngIf="canSave()"
                        (click)="$event.preventDefault(); openAdd();"
                        class="px-2 py-1.5 flex flex-row gap-2 items-center justify-center rounded-md bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200 text-white oswald-font">
                        <lucide-icon [img]="icons.Plus"></lucide-icon>
                        Add New
                    </button>
                </div>

                <ng-container *ngIf="kitsList.length > 0; else emptyList">
                    <div class="h-full w-full overflow-y-auto">
                        <table class="w-full text-left table-fixed">
                            <thead class="oswald-font text-gray-700 uppercase bg-main-background">
                                <tr>
                                    <th scope="col" class="h-12 px-4 py-3 w-14">
                                        <div class="flex items-center justify-start gap-1 whitespace-nowrap">No.</div>
                                    </th>
                                    <th scope="col" class="px-4 py-3 w-1/2">
                                        <div (click)="$event.preventDefault(); sortList('name')" class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                            Name
                                            <lucide-icon [name]="icons.ArrowUpDown" [size]=20 class="ms-1"></lucide-icon>
                                        </div>
                                    </th>
                                    <th scope="col" class="px-4 py-3 w-1/3">
                                        <div (click)="$event.preventDefault(); sortList('location')" class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                            Location
                                            <lucide-icon [name]="icons.ArrowUpDown" [size]=20 class="ms-1"></lucide-icon>
                                        </div>
                                    </th>
                                    <th scope="col" class="px-4 py-3" *ngIf="canSave()">
                                        <div class="flex items-center justify-start gap-1 whitespace-nowrap">Actions</div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of kitsList | paginate: { itemsPerPage: itemsPerPage, currentPage: page }; let i=index;" class="bg-white border-b">
                                    <th scope="row" class="px-4 py-4 align-top">
                                        {{ i + 1 + (page - 1) * itemsPerPage }}
                                    </th>
                                    <td class="px-4 py-4 font-medium align-top">
                                        <p class="w-full break-all [overflow-wrap:anywhere] whitespace-pre-line">{{ item.name }}</p>
                                    </td>
                                    <td class="px-4 py-4 font-medium align-top">
                                        <p class="w-full break-all [overflow-wrap:anywhere] whitespace-pre-line">{{ item.location }}</p>
                                    </td>
                                    <td class="px-4 py-4 font-medium align-top" *ngIf="canSave()">
                                        <div class="flex gap-2">
                                            <button
                                                (click)="$event.preventDefault(); openEdit(item);"
                                                class="w-full max-w-20 py-2 px-1 font-normal text-white oswald-font border border-nside-orange-300 bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 rounded-md hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200 cursor-pointer">
                                                Edit
                                            </button>
                                            <button
                                                (click)="$event.preventDefault(); openDelete(item);"
                                                class="w-full max-w-20 py-2 px-1 font-normal text-white oswald-font border border-nside-gray-300 bg-gradient-to-b from-nside-gray-300 to-nside-gray-400 rounded-md hover:bg-gradient-to-b hover:from-nside-gray-100 hover:to-nside-gray-200 cursor-pointer">
                                                Delete
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </ng-container>
                <ng-template #emptyList>
                    <div class="w-full text-nside-gray-100 italic text-start">
                        Empty list
                    </div>
                </ng-template>
                <div class="w-full flex justify-between items-center">
                    <p>{{ kitsList.length }} in total</p>
                    <pagination-controls
                        *ngIf="kitsList.length > itemsPerPage"
                        (pageChange)="page = $event"
                        previousLabel="Prev"
                        nextLabel="Next"
                        class="mt-2"
                    ></pagination-controls>
                </div>
            </div>
        </div>
    </div>

    <introduction></introduction>

    <emergency-evacuation-kit-form
        *ngIf="showForm"
        [itemToEdit]="formItem"
        (onClose)="closeForm()"
        (onSave)="handleSaved($event)"
    ></emergency-evacuation-kit-form>

    <delete-confirmation
        *ngIf="showDeleteConfirmation"
        [text]="'this evacuation kit'"
        [itemToDelete]="selectedItem"
        (onClose)="closeDelete()"
        (onDelete)="handleDelete($event)"
    ></delete-confirmation>

    <prv-next-buttons></prv-next-buttons>

    <div *ngIf="loading">
        <spinner></spinner>
    </div>

    <popup-message
        [type]="messageModal"
        [message]="popupMessage"
        (close)="resetMessageModal()"
    ></popup-message>
</main>
